import { useState } from "@wordpress/element";
import { useTranslation } from "react-i18next";

import iconInternationalization from "@/img/icon-internatiolization.svg";

import "./style.scss";

export const App = () => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const { t } = useTranslation();
	const pathName = window.location.pathname.split("/")[2] ?? "/";

	return (
		<div
			className="internationalization-container"
			onClick={() => setIsOpen((prev) => !prev)}
		>
			<img src={iconInternationalization} alt={"Language selector"} />

			<p>{t("language")}</p>

			{isOpen && (
				<ul>
					<li>
						<a href={`/en/${pathName}`}>ENG</a>
					</li>
					<li>
						<a href={`/ar/${pathName}`}>AR</a>
					</li>
				</ul>
			)}
		</div>
	);
};

export default App;
